<div id="errorModal">
  <div class="modal-content">
    <div class="modalContainer">
      <form action="">
        <div class="cardModalTitle">
          <h4 data-title="title">{{ title }}</h4>
          <span
            class="close"
            mat-raised-button
            mat-dialog-close
            (click)="closeErrorIntern()"
          >
            <img src="assets/img/close-white.svg" alt="" />
          </span>
        </div>
        <div class="cardModalContent">
          <p class="error-description" data-message="description">
            {{ description }}
          </p>
        </div>
        <div class="content-text">
          <div class="text-poursuivre">
            Poursuivez votre souscription en ligne avec nos agents par
            <b>téléphone</b> ou sur le <b>chat</b>&nbsp;:
          </div>
        </div>
        <br />
        <div class="txtMilieu">
          <div class="phone-div">
            <img src="assets/img/phone2.svg" alt="te" />
            <p class="phone-number">01 83 77 22 02</p>
          </div>
          <p class="text-phone">
            Appel & Service gratuit · Lundi au vendredi de 9h à 19h
          </p>
        </div>

        <div class="prendre-rendez-vous">
          <a
            href="https://calendly.com/conseiller_mtxsante/rdv_commercial"
            class="prendre-rendez-vous__link"
            target="_blank"
            ><img src="../../../../../../assets/img/iconeRDV.svg" alt="" />
            Prendre rendez-vous</a
          >
        </div>
      </form>
    </div>
  </div>
</div>
